import { Container, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import Box from '@mui/material/Box';
import { Form } from '@unform/web';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextField from '../../components/fields/TextFieldUI';
import SelectParameter from '../../components/Form/SelectParameter';
import AlertDialog from '../../components/ui/AlertDialog';
import ButtonUI from '../../components/ui/ButtonUI';
import GridSelect from '../../components/ui/GridSelect';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import Select, { SelectOption } from '../../components/ui/selec';
import { useAuth } from '../../hooks/auth';
import { ParameterSearch } from '../../interfaces/Parameter';
import GenericApi from '../../services/GenericApi';
import MvmApi from '../../services/MvmApi';
import SupplierApi from '../../services/SupplierApi';
import { useStyles } from './Style';

const Parameter: React.FC = () => {
    const classes = useStyles();
    const [parameters, setParameters] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const { user, hasPermission  } = useAuth();
    const { t } = useTranslation("Parameter");
    const { t: _t } = useTranslation("General");
    const { enqueueSnackbar } = useSnackbar();
    
    const { control, getValues, setValue: setValues } = useForm<any>();

    const [tabs] = useState<any>();
    const [tabsContent, setTabsContent] = useState<any>(null);
    const [value, setValue] = React.useState(0);
    const [selects, setSelects] = useState<any[][]>([]);
    const [defaultValues, setDefaultValues] = useState<any>(null);
    const [items, setItems] = useState<any[]>([]);
    const [suppliers, setSuppliers] = useState<any[]>([]);  

    useEffect(() => {
        if (parameters && defaultValues)
            PrepareNavigationTabs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parameters, selects, value, defaultValues]);

    const loadDefaultValues = async () => {
        setLoading(true);
        const result = await MvmApi.searchParameter({Code: '',Value: '',Type: '',PlantId: Number(user.company.plantID),SystemId: 10});

        const valuesFromApi = result.filter((x: any) => x.parameter.type === 'M');
        let itemSuppliers = '';
        
        valuesFromApi.forEach((element: any) => {
            itemSuppliers+= ',' + element.parameter.value;
        });
        
        const supplierIdsToSearch = itemSuppliers
            .slice(1)
            .split(',')
            .filter((x: string) => x.trim() !== '');

        // Uma unica chamada para resolver os fornecedores ja selecionados (todas as listas).
        let loadedSuppliers: any[] = [];
        if (supplierIdsToSearch.length > 0) {
            const resultSuppliers = await SupplierApi.searchSuppliers(supplierIdsToSearch, user.company.plantID, user.company.companyID, supplierIdsToSearch.length);
            loadedSuppliers = resultSuppliers.items ?? [];
        }
        setSuppliers(loadedSuppliers);

        const nextDefaultValues: any = {};
        const resultPromises: any[] = [];

        valuesFromApi.forEach((element: any) => {
            const key = element.code.replace('.', '-');

            if (element.parameter.value !== '')
         {
                const idsDoParametro = element.parameter.value.split(',');
                const selectedValues = loadedSuppliers
                    .filter((supplier: any) => idsDoParametro.includes(String(supplier.supplierID)))
                    .map((supplier: any) => ({
                        label: `${supplier.supplierID} - ${supplier.name.trim()}`,
                        code: supplier.supplierID,
                        name: supplier?.name?.trim(),
                    }
                ));

                nextDefaultValues[key] = selectedValues;
                setValues(key, selectedValues);
            }else {
                nextDefaultValues[key] = element.parameter.value;
            }
            resultPromises.push(key);
        });

        setDefaultValues({ ...nextDefaultValues });
        setItems(resultPromises);

        setLoading(false);
    }


    useEffect(() => {
        async function load()
        {
            await loadDefaultValues();

            await GetParameters({
                Code: '',
                Value: '',
                Type: '',
                PlantId: Number(user.company.plantID),
                SystemId: 10
            });
        }

        load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    function handleDeleteItem(id: number) {
    };

     async function GetParameters(data: ParameterSearch)
     {
        setLoading(true);
        //data.SupplierCode = supplierId;
        const result = await MvmApi.searchParameter(data);
        setParameters(groupBy(result, "groupDescription"));
        setLoading(false);
                
    }

    const handleSubmit = async (data: any) => {
            const postData: any = {items: []};
            Object.entries(data).forEach((i: any) => {
                postData.items.push({code: i[0].replace('-', '.'), value: Array.isArray(i[1]) ? i[1].toString() : i[1],  plantId: user.company.plantID, systemId: 10})
            })
            const formData = getValues();
            const values: any[] = [];

            if (formData !== undefined) {
                items.forEach((code: any) => {
                    values[code] = [];
                    formData[code].forEach((element: any) => {
                        values[code].push(element.code);
                    });
                })

                items.forEach(code => {
                    postData.items.push({code: code.replace('-', '.'), value: values[code].join(","),  plantId: user.company.plantID, systemId: 10});
                })
            }
            
            // return;
            setLoading(true);
            await MvmApi.UpdateList(postData)
                    .then(result => {
                        GetParameters({
                            Code: '',
                            Value: '',
                            Type: '',
                            PlantId: Number(user.company.plantID),
                            SystemId: 10
                        });
                        enqueueSnackbar(t("returnSubmitEditFormSuccess"), { variant: 'success' });                     
                    }).catch(err => {
                        enqueueSnackbar(t("returnSubmitEditFormError"), { variant: 'error' });                     
                    }).finally(() => {
                        setLoading(true);
                    });
    };
       

        function groupBy(collection:any, property:any) {
            var i = 0, val, index,
                values = [], result = [];
            for (; i < collection.length; i++) {
                val = collection[i][property];
                index = values.indexOf(val);
                if (index > -1)
                    result[index].push(collection[i]);
                else {
                    values.push(val);
                    result.push([collection[i]]);
                }
            }
            return result;
        }
        
       async function PrepareNavigationTabs()
        {
            // var navigationTabs = parameters.map(
            //     (group: any, index: number) => ( 
            //         <Tab key={group[0].groupDescription.replace(/ /g, "")} label={group[0].groupDescription} {...a11yProps(index)} /> 
            //     ))
            // setTabs(navigationTabs);
            PrepareContentTabs();
        }

        function PrepareContentTabsElements(group:any[])
        {
            let elements: JSX.Element[] = [];
            let index:number = 0;
            group.forEach((element: any, elementIndex: number) => {
                if(element.urlValues == null)
                {
                    if (hasPermission(element?.permissionDescription))
                    {
                        elements.push(
                            <Grid  key={element.tittle.replace(/ /g, "").concat("-").concat(elementIndex)}  item xs={12}>
                                <TextField
                                    key={element.tittle.replace(/ /g, "").concat(elementIndex)}
                                    label={element.tittle}
                                    name={element.code.replace('.', '-')}
                                    required={true}
                                    className={classes.rootForm}
                                    defaultValue={element.parameter.value}
                                    style={{ maxWidth: "500px", minWidth: "300px" }}
                                    // onChange={(e: any, value:any) => setValues(element.code.replace('.', '-'), value)}
                                    />
                            </Grid>
                        );   
                    }
                }
                else
                {
                    if (element.parameter.type === 'M')
                    {
                        
                        let selectedValues: any[] = [];                  

                        selectedValues =  suppliers.filter((item: any) => element.parameter?.value.includes(item.supplierID)).map((supplier: any) => {
                            return {
                                label: `${supplier.supplierID} - ${supplier.name.trim()}`,
                                code: supplier.supplierID,
                                name: supplier?.name?.trim(),
                            }
                        });

                        elements.push(
                            <GridSelect key={element.tittle.replace(/ /g, "").concat("-").concat(elementIndex)} item xs={12}>
                                <SelectParameter
                                    key={element.tittle.replace(/ /g, "").concat(elementIndex)}
                                    name={element.code.replace('.', '-')}
                                    multiple={element.indMultipleChoice}
                                    defaultValue={element.indMultipleChoice &&  element.parameter?.value !== '' ? selectedValues : element.parameter.value}
                                    label={element.tittle}
                                    // onChange={(e: any, value:any) => setValues(element.code.replace('.', '-'), value)}
                                    control={control}
                                    style={{ maxWidth: "100%", minWidth: "300px" }}
                                />
                            </GridSelect>
                        );
                    }else{
                        let list:any = selects;
                        let url = element.urlValues.split("/api");
                        if(selects.length <= index+1)
                            GenericApi.GenericGet(url[0],url[1]+`&plantId=${user.company.plantID}`).then(response => {
                                if (response?.items?.length > 0)
                                {
                                    list.push(response?.items);
                                    setSelects(list);
                                    PrepareNavigationTabs();
                                }
                            });
                        
                        if(selects.length >= index+1)
                        {
                            if (hasPermission(element?.permissionDescription))
                            {
                                const options: any[] = [];
                                selects[index].forEach(i => options.push({ text: i.description, value: i.code }));
                                elements.push(
                                    <GridSelect key={element.tittle.replace(/ /g, "").concat("-").concat(elementIndex)} item xs={12}>
                                        <Select 
                                            key={element.tittle.replace(/ /g, "").concat(elementIndex)}
                                            name={element.code.replace('.', '-')}
                                            multiple={element.indMultipleChoice}
                                            options={options} 
                                            onChange={(e: any, value:any) => setValues(element.code.replace('.', '-'), value)}
                                            defaultValue={element.indMultipleChoice ? element.parameter.value.split(',') : element.parameter.value}
                                            label={element.tittle}
                                            style={{ maxWidth: "100%", minWidth: "300px" }}
                                        />
                                    </GridSelect>);
                            }
                        }
                    }

                    index++;
                } 
            });

            return elements;
        }

        async function PrepareContentTabs()
        {
            var contentTabs = parameters.map((group: any, index: number) => ( 
                <div >
                    <Box sx={{ pt: 4 }}>
                        <Typography style={{fontSize: 20, fontWeight: 'bold'}}>{group[0].groupDescription}</Typography>
                        <Divider />
                    </Box>
                    <Grid container style={{paddingLeft: 0}}>
                        {PrepareContentTabsElements(group)}
                    </Grid>                       
                </div>
            ))

            setTabsContent(contentTabs)
        }
    
    if (loading)
        return <LoadingUI />


    return (
        <Container maxWidth={false} component="main">
            
            <PageTitle title={t("manageSystemSettings")} />
            {parameters.length > 0 && (
                <Grid container style={{padding: 16}}>
                    <Form translate={undefined}  onSubmit={handleSubmit} key='formMain'>                          
                        <Box sx={{ width: '100%' }} >               
                            { tabs /*PrepareNavigationTabs()*/}
                            {tabsContent ?? <></>}
                            
                        </Box>
                        <ButtonUI
                            type='submit'
                            variant="outlined"
                            // startIcon={<SaveIcon />}
                        >
                            Salvar
                        </ButtonUI>
                    </Form>
                </Grid>
            )}
        </Container>
    )
}
export default Parameter;
